import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  Autocomplete,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';

export const AdminAssetSec13Component = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [feOptions, setFeOptions] = useState([]);
  const [feLoading, setFeLoading] = useState(true);

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [formData, setFormData] = useState({
    fe: null,
    property_detals: '',
    survey_no: '',
    property_type: '',
    type_of_asset: '',
    hobli: '',
    village: '',
    taluk: '',
    district: '',
    state: '',
    pincode: '',
    geo_location: '',
    misc_no: '',
    appeal: '',
    doc: '',
    status: '',
    final_ord: '',
    Final_remark: '',
  });

  const [formErrors, setFormErrors] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 60 },
    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'FE Name', width: 180 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 180 },
    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
    { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
    { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
    { id: 'village', field: 'village', headerName: 'Village', width: 120 },
    { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
    { id: 'district', field: 'district', headerName: 'District', width: 120 },
    { id: 'state', field: 'state', headerName: 'State', width: 120 },
    { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
    { id: 'geo_location', field: 'geo_location', headerName: 'Geo Location', width: 160 },
    { id: 'misc_no', field: 'misc_no', headerName: 'Misc No', width: 120 },
    { id: 'appeal', field: 'appeal', headerName: 'Appeal', width: 120 },
    { id: 'doc', field: 'doc', headerName: 'Document', width: 200 },
    { id: 'status', field: 'status', headerName: 'Status', width: 120 },
    { id: 'final_ord', field: 'final_ord', headerName: 'Final Order', width: 200 },
    { id: 'Final_remark', field: 'Final_remark', headerName: 'Final Remark', width: 200 },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 130,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchFEOptions();
    fetchRows();
  }, []);

  const fetchFEOptions = () => {
    setFeLoading(true);
    axios.get(`${API_BASE_URL}/home-notification/assignedfe/`)
      .then(res => setFeOptions(res.data))
      .catch(() => {
        setSnackbarMessage('Failed to load FE options');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => setFeLoading(false));
  };

  const fetchRows = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/asset-mgmt/asset-sec13/`)
      .then(({ data }) => {
        const mapped = data.map((item, idx) => ({
          id: item.id,
          slNo: idx + 1,
          name_of_fe: item.fe?.name_of_fe || '-',
          name_of_ca: item.fe?.name_of_ca || '-',
          ...item,
        }));
        setRows(mapped);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load records');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setSelectedRecord(null);
    setFormData({
      fe: null,
      property_detals: '',
      survey_no: '',
      property_type: '',
      type_of_asset: '',
      hobli: '',
      village: '',
      taluk: '',
      district: '',
      state: '',
      pincode: '',
      geo_location: '',
      misc_no: '',
      appeal: '',
      doc: '',
      status: '',
      final_ord: '',
      Final_remark: '',
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (row) => {
    const selectedFE = feOptions.find(f => f.id === row.fe?.id) || null;
    setIsEditMode(true);
    setSelectedRecord(row);
    setFormData({
      fe: selectedFE,
      property_detals: row.property_detals || '',
      survey_no: row.survey_no || '',
      property_type: row.property_type || '',
      type_of_asset: row.type_of_asset || '',
      hobli: row.hobli || '',
      village: row.village || '',
      taluk: row.taluk || '',
      district: row.district || '',
      state: row.state || '',
      pincode: row.pincode || '',
      geo_location: row.geo_location || '',
      misc_no: row.misc_no || '',
      appeal: row.appeal || '',
      doc: row.doc || '',
      status: row.status || '',
      final_ord: row.final_ord || '',
      Final_remark: row.Final_remark || '',
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (row) => {
    setDeleteRecord(row);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/asset-mgmt/asset-sec13/${deleteRecord.id}/`)
      .then(() => {
        setSnackbarMessage('Record deleted.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchRows();
      })
      .catch(() => {
        setSnackbarMessage('Delete failed.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteRecord(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fe) errors.fe = "Financial Establishment is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;
    setSubmitLoading(true);
    const payload = {
      fe: formData.fe.id,
      property_detals: formData.property_detals,
      survey_no: formData.survey_no,
      property_type: formData.property_type,
      type_of_asset: formData.type_of_asset,
      hobli: formData.hobli,
      village: formData.village,
      taluk: formData.taluk,
      district: formData.district,
      state: formData.state,
      pincode: formData.pincode,
      geo_location: formData.geo_location,
      misc_no: formData.misc_no,
      appeal: formData.appeal,
      doc: formData.doc,
      status: formData.status,
      final_ord: formData.final_ord,
      Final_remark: formData.Final_remark,
    };
    const req = isEditMode ?
      api.patch(`/asset-mgmt/asset-sec13/${selectedRecord.id}/`, payload) :
      api.post(`/asset-mgmt/asset-sec13/`, payload);
    req.then(() => {
      setSnackbarMessage(isEditMode ? 'Updated successfully' : 'Added successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchRows();
    }).catch(() => {
      setSnackbarMessage(isEditMode ? 'Update failed' : 'Add failed');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }).finally(() => {
      setSubmitLoading(false);
      setOpenFormDialog(false);
    });
  };


  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
        <Typography variant="h4" fontWeight="bold">Admin Asset Sec 13</Typography>
        <Button variant="contained" onClick={handleAdd}>Add</Button>
      </Box>

      {loading ? <LoadingSpinner size={30} /> :
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
        />
      }

      {/* Add/Edit dialog */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Record' : 'Add Record'}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

          <Autocomplete
            options={feOptions}
            getOptionLabel={option => option.name_of_fe || ''}
            loading={feLoading}
            value={formData.fe}
            onChange={(e, newValue) => setFormData({ ...formData, fe: newValue })}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Financial Establishment"
                margin="dense"
                error={!!formErrors.fe}
                helperText={formErrors.fe}
                required
              />
            )}
          />

          <TextField label="Property Details" value={formData.property_detals} onChange={e => setFormData({ ...formData, property_detals: e.target.value })} fullWidth margin="dense" />
          <TextField label="Survey No" value={formData.survey_no} onChange={e => setFormData({ ...formData, survey_no: e.target.value })} fullWidth margin="dense" />
          <TextField label="Property Type" value={formData.property_type} onChange={e => setFormData({ ...formData, property_type: e.target.value })} fullWidth margin="dense" />
          <TextField label="Type of Asset" value={formData.type_of_asset} onChange={e => setFormData({ ...formData, type_of_asset: e.target.value })} fullWidth margin="dense" />
          <TextField label="Hobli" value={formData.hobli} onChange={e => setFormData({ ...formData, hobli: e.target.value })} fullWidth margin="dense" />
          <TextField label="Village" value={formData.village} onChange={e => setFormData({ ...formData, village: e.target.value })} fullWidth margin="dense" />
          <TextField label="Taluk" value={formData.taluk} onChange={e => setFormData({ ...formData, taluk: e.target.value })} fullWidth margin="dense" />
          <TextField label="District" value={formData.district} onChange={e => setFormData({ ...formData, district: e.target.value })} fullWidth margin="dense" />
          <TextField label="State" value={formData.state} onChange={e => setFormData({ ...formData, state: e.target.value })} fullWidth margin="dense" />
          <TextField label="Pincode" value={formData.pincode} onChange={e => setFormData({ ...formData, pincode: e.target.value })} fullWidth margin="dense" />
          <TextField label="Geo Location" value={formData.geo_location} onChange={e => setFormData({ ...formData, geo_location: e.target.value })} fullWidth margin="dense" />
          <TextField label="Misc No" value={formData.misc_no} onChange={e => setFormData({ ...formData, misc_no: e.target.value })} fullWidth margin="dense" />
          <TextField label="Appeal" value={formData.appeal} onChange={e => setFormData({ ...formData, appeal: e.target.value })} fullWidth margin="dense" />
          <TextField label="Document" value={formData.doc} onChange={e => setFormData({ ...formData, doc: e.target.value })} fullWidth multiline rows={3} margin="dense" />
          <TextField label="Status" value={formData.status} onChange={e => setFormData({ ...formData, status: e.target.value })} fullWidth margin="dense" />
          <TextField label="Final Order" value={formData.final_ord} onChange={e => setFormData({ ...formData, final_ord: e.target.value })} fullWidth multiline rows={3} margin="dense" />
          <TextField label="Final Remark" value={formData.Final_remark} onChange={e => setFormData({ ...formData, Final_remark: e.target.value })} fullWidth multiline rows={3} margin="dense" />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit} disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure want to delete this record?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDelete} disabled={submitLoading}>Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
